(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class Pac12HeaderScroll {
    constructor() {
      this.overlay = document.querySelector('[data-pac12-header-overlay]');
      this.sectionHeader = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('[data-pac12-announcement-bar]');
      this.opacityStart = 0;
      this.opacityEnd = 0.96;
      this.scrollDistance = 300;
      this.scrollThreshold = 64;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
      this.initDropdowns();
      this.initDrawerClose();
    }

    onScroll() {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      const opacityRange = this.opacityEnd - this.opacityStart;
      const opacity = Math.min(
        this.opacityStart + (scrollY / this.scrollDistance) * opacityRange,
        this.opacityEnd
      );

      if (this.overlay) {
        this.overlay.style.opacity = String(opacity);
      }

      if (this.sectionHeader) {
        if (scrollY >= this.scrollThreshold) {
          this.sectionHeader.setAttribute('data-pac12-scrolled', 'true');
        } else {
          this.sectionHeader.removeAttribute('data-pac12-scrolled');
        }
      }

      const announcementSection = this.announcementBar?.closest('.announcement-bar-section');
      if (announcementSection) {
        if (scrollY >= this.scrollThreshold) {
          announcementSection.classList.add('pac12-announcement-bar--hidden');
        } else {
          announcementSection.classList.remove('pac12-announcement-bar--hidden');
        }
      }
    }

    initDropdowns() {
      const dropdowns = document.querySelectorAll('.pac12-nav__item-wrap--dropdown');
      const gutter = 16;
      const xlBreakpoint = 1280;

      dropdowns.forEach((wrap) => {
        const details = wrap.querySelector('details');
        const panel = wrap.querySelector('.pac12-nav__panel');
        const summary = wrap.querySelector('summary');
        if (!details || !panel || !summary) return;

        const positionPanel = () => {
          const maxWidth = window.innerWidth >= xlBreakpoint ? 760 : 600;
          const panelWidth = Math.min(maxWidth, Math.max(0, window.innerWidth - gutter * 2));
          const triggerRect = summary.getBoundingClientRect();
          // Centre the panel in the viewport rather than on the trigger, so it
          // sits in the same place for every menu item. Still clamped to the
          // gutter so it can never overflow on narrow widths.
          const minLeft = gutter;
          const maxLeft = Math.max(minLeft, window.innerWidth - gutter - panelWidth);
          const left = Math.min(Math.max((window.innerWidth - panelWidth) / 2, minLeft), maxLeft);
          panel.style.width = `${panelWidth}px`;
          panel.style.left = `${left}px`;
          panel.style.top = `${triggerRect.bottom}px`;
        };

        const open = () => {
          details.setAttribute('open', '');
          positionPanel();
        };

        const close = () => {
          details.removeAttribute('open');
        };

        wrap.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 990px)').matches) open();
        });

        wrap.addEventListener('mouseleave', () => {
          if (window.matchMedia('(min-width: 990px)').matches) close();
        });

        window.addEventListener('resize', () => {
          if (details.hasAttribute('open')) positionPanel();
        });
      });
    }

    initDrawerClose() {
      document.querySelectorAll('[data-pac12-drawer-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const details = document.getElementById('Details-menu-drawer-container');
          if (details) {
            details.removeAttribute('open');
            details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new Pac12HeaderScroll();
  });

  } catch(e) { console.error(e); }
})();
})();
